module.exports = __webpack_public_path__ + "img/loading_img.a5672195.gif";